import { createFileRoute } from "@tanstack/react-router";
import { ConsumerLayout } from "@/components/layout/consumer-layout";
import { HomePage } from "@/features/home/home-page";

export const Route = createFileRoute("/")({
  component: HomeRoute,
});

function HomeRoute() {
  return (
    <ConsumerLayout transparentHeader>
      <HomePage />
    </ConsumerLayout>
  );
}
